import {gql} from '@apollo/client';

export const MUTATION_CREATE_ORDER = gql`
mutation createOrder($data: OrderInput!) {
    createOrder(data: $data) {
        documentId
        order_status
    }
}`

export const QUERY_ORDER = gql`
query order($documentId: ID!) {
    order(documentId: $documentId) {
        id
        documentId
        order_status
        first_name
        last_name
        email
        phone
        delivery
        delivery_data
        promo
        cost_sum
        cost_discount
        cost_delivery
        cost_total
        promo_accepted
        positions
    }
}`